import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107211Status: 'idle',
    startProcess107211Error: undefined as any,
    loadUserParamsProcess107211Status: 'idle',
    loadUserParamsProcess107211Error: undefined as any,

    process107211List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107211 = createAsyncThunk('process107211Slice/startProcess107211', async ({ process107211 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107211/`,
        prepareData(process107211),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107211Status } = getState().process107211Slice
        return startProcess107211Status !== 'pending'
    }
})

export const loadUserParamsProcess107211 = createAsyncThunk('process107211Slice/loadUserParamsProcess107211', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107211/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107211Status } = getState().process107211Slice
        return loadUserParamsProcess107211Status !== 'pending'
    }
})

const Process107211Slice = createSlice({
    name: 'process107211Slice',
    initialState,
    reducers: {
        resetstartProcess107211: (state) => {
            state.job = undefined
            state.startProcess107211Error = undefined
        },
        resetstartProcess107211Error: (state) => {
            state.startProcess107211Error = undefined
        },
        resetloadUserParamsProcess107211: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107211Error = undefined
        },
        resetloadUserParamsProcess107211Error: (state) => {
            state.loadUserParamsProcess107211Error = undefined
        },
        removeFromProcess107211ListById: (state, action) => {
            state.process107211List = state.process107211List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107211ListByIds: (state, action) => {
            state.process107211List = state.process107211List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107211List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107211Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107211List = []
            state.startProcess107211Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107211.pending, (state) => {
            state.startProcess107211Status = 'pending'
            state.startProcess107211Error = undefined
        })
        builder.addCase(startProcess107211.fulfilled, (state, action) => {
            state.startProcess107211Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107211.rejected, (state, action) => {
            state.startProcess107211Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107211Error = action.error.message
            } else {
                state.startProcess107211Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107211.pending, (state) => {
            state.loadUserParamsProcess107211Status = 'pending'
            state.loadUserParamsProcess107211Error = undefined
        })
        builder.addCase(loadUserParamsProcess107211.fulfilled, (state, action) => {
            state.loadUserParamsProcess107211Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107211.rejected, (state, action) => {
            state.loadUserParamsProcess107211Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107211Error = action.error.message
            } else {
                state.loadUserParamsProcess107211Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107211,
    resetstartProcess107211Error,
    resetloadUserParamsProcess107211,
    resetloadUserParamsProcess107211Error,
    removeFromProcess107211ListById,
    removeFromProcess107211ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107211Slice.actions
export default Process107211Slice.reducer
